export const isMobile = () => window.innerWidth < 768;

export const getBrandLogoUrl = (theme) => {
    if(theme==='dark')
        return "https://www.urbancompany.com/img/images/growth/home-screen/1631097450980-d2de38.png?bucket=urbanclap-prod&quality=80&format=auto";
    if(theme==='white')
        return "https://www.urbancompany.com/img/images/supply/partner-training/1628575858610-5b0ae4.png?bucket=urbanclap-prod&quality=90&format=auto";
}